import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ggi-26",
  "use": "icon-ggi-26-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ggi-26\">\n<rect x=\"6\" y=\"4\" width=\"12\" height=\"16\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" />\n<path d=\"M10 12.4996L11.5003 13.9999L14.5001 11\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<rect x=\"10\" y=\"4\" width=\"4\" height=\"3\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol